import React from 'react';
import styles from 'Custom/Question/index.module.scss';
import RichText from 'Custom/RichText';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import QuestionIcon from 'Images/brand-icons/question-icon.svg';
import QuestionDarkIconDesktop from 'Images/brand-icons/question-dark-icon-desktop.svg';
import QuestionIconMobile from 'Images/brand-icons/question-icon-mobile.svg';
import QuestionDarkIconMobile from 'Images/brand-icons/question-dark-icon-mobile.svg';

const WRAPPER_DIRECTION = {
  column: styles.column,
  row: styles.row,
  default: styles.column,
};

const WRAPPER_SIZE = {
  large: styles.large,
  small: styles.small,
  default: styles.small,
};

const TITLE_SIZE = {
  large: styles.titleLarge,
  small: styles.titleSmall,
  default: styles.titleSmall,
};

const Question = ({
  question = [],
  direction = 'column',
  size = 'small',
  titSize = 'small',
  className = '',
}) => {
  const wrapperDirection =
    WRAPPER_DIRECTION[direction] || WRAPPER_DIRECTION.default;
  const wrapperSize = WRAPPER_SIZE[size] || WRAPPER_SIZE.default;
  const titleSize = TITLE_SIZE[titSize] || TITLE_SIZE.default;

  return (
    <>
      {question.map((item, index) => {
        const {
          questionTitle: itemTitle,
          questionContent: itemContent,
          customStyle = false,
        } = item;

        return (
          <div
            className={`${
              styles.questionWrapper
            } ${wrapperDirection} ${wrapperSize} ${className ? className : ''}`}
            key={index}
            data-qa-tag="question-wrapper"
          >
            <div
              className={`${styles.title}`}
              data-qa-tag="question-title-wrapper"
            >
              <ItemBreakpoint breakpoint={'lg'}>
                {className ? (
                  <QuestionDarkIconDesktop data-qa-tag="question-title-darkImage-desktop" />
                ) : (
                  <QuestionIcon data-qa-tag="question-title-image-desktop" />
                )}
                {className ? (
                  <QuestionDarkIconMobile data-qa-tag="question-title-darkImage-mobile" />
                ) : (
                  <QuestionIconMobile data-qa-tag="question-title-image-mobile" />
                )}
              </ItemBreakpoint>
              <RichText data-qa-tag="question-title">
                <h3 className={`${titleSize}`}>{itemTitle}</h3>
              </RichText>
            </div>
            <div
              className={`${styles.content} ${
                customStyle ? styles.mobilePadding : ''
              }`}
              data-qa-tag="question-content"
            >
              <RichText>{itemContent}</RichText>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Question;
